module.exports = __webpack_public_path__ + "img/Banner-image-Delivery-Mobile.806f03dc.jpg";